import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  FONT_PROXIMA_14,
  FONT_WEIGHT_PROXIMA_REGULAR,
  FONT_WEIGHT_PROXIMA_SEMIBOLD,
} from 'styles/FontConstants';
import {GRAY_DARKER, RED_LIGHTEST} from 'ui-library/Colors';

export function DataCaptureFailureIndicator(): JSX.Element {
  return (
    <div className={css(styles.progressFailedContainer)} data-testid="progress-failed-message">
      <div className={css(styles.progressHeader)}>
        <span>Request failed</span>
      </div>
      <div className={css(styles.progressContent)}>
        <span className={css(styles.errorMessage)}>An unexpected error occurred. Please try again.</span>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  progressFailedContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    padding: '16px',
    gap: '4px',
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    backgroundColor: RED_LIGHTEST,
  },

  progressHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '8px',
  },

  progressContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  errorMessage: {
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: GRAY_DARKER,
  },
});
